import axios from "axios";

export const state = {
    shareholderdividends: [],
};

export const getters = {
    shareholderdividends: state => state.shareholderdividends,
};

export const mutations = {
    setShareHolderDividend(state, newValue) {
        state.shareholderdividends = newValue
    },
};

export const actions = {
    async fetchShareHolderDividend({ commit }) {
        await axios.get('/shareholderdividends').then(res => {
            commit('setShareHolderDividend', res.data.dividends)
        })
    },
};
